export const DASHBOARD_DRAFT_COUNT = 'DASHBOARD_DRAFT_COUNT'
